import axios from '../../utilities/axios';
import { ofType } from 'redux-observable';
import { of, merge } from 'rxjs';
import { mergeMap, switchMap, catchError } from 'rxjs/operators';
import { primaryApi } from '../../utilities/apiEndpointUtility';
import {
	failureMessage,
	successMessage
} from '../Notifications/notificationsSlice';

import i18n from '../../i18n';

import {
	createTag,
	createTagCompleted,
	createTagFailed,
	getTags,
	getTagsCompleted,
	getTagsFailed
} from './tagsSlice';

export const createTagEpic = (action$) =>
	action$.pipe(
		ofType(createTag.type),
		mergeMap(async (action) => {
			try {
				const newTag = action.payload;
				const tag = await axios.post(`${primaryApi()}/api/v1/tags`, newTag);

				return tag.data;
			} catch (e) {
				return {
					error: e.message
				};
			}
		}),
		switchMap((res) => {
			return [
				createTagCompleted(res),
				getTags(),
				successMessage(i18n.t('notifications.tagCreateSuccess'))
			];
		}),
		catchError((error, source) => {
			return merge(
				of(createTagFailed(error.message), failureMessage(error.message)),
				source
			);
		})
	);

export const getTagsEpic = (action$) =>
	action$.pipe(
		ofType(getTags.type),
		mergeMap(async (action) => {
			try {
				const tags = await axios.get(`${primaryApi()}/api/v1/tags`);

				return tags.data;
			} catch (e) {
				return {
					error: e.message
				};
			}
		}),
		switchMap((res) => {
			return [getTagsCompleted(res)];
		}),
		catchError((error, source) => {
			return merge(
				of(getTagsFailed(error.message), failureMessage(error.message)),
				source
			);
		})
	);

export default [createTagEpic, getTagsEpic];
